import { SagaIterator } from 'redux-saga';
import { call, delay, put, select, take, takeEvery, takeLeading } from 'redux-saga/effects';
import {
  AngebotsId,
  GlobalAction,
  GlobalActions,
  GlobalPut,
  ModalType,
  NavigationRoute,
  SpeichernStatus,
} from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { IAppState } from '../localStore';
import { LocalActions } from '../local.actions';
import { isStreckenApp } from './loadAvSaga';

let lastNavigatedAngebot: AngebotsId;

export function* watchAppHasBeenUpdated(): SagaIterator {
  yield takeLeading(GlobalActions.APP_HAS_BEEN_UPDATED, safeSaga(appHasBeenUpdated, App.SHOP));
  yield takeEvery(GlobalActions.NAVIGATION_COMPLETED, safeSaga(setCurrentApp, App.SHOP));
}

export function setCurrentApp(action: GlobalAction<NavigationRoute>): void {
  lastNavigatedAngebot = {
    appId: action.payload.appId,
    angebotsId: action.payload.angebotsId,
  };
}

export const setWindowLocation = function (locationHref: string): void {
  window.location.href = locationHref;
};

export function* appHasBeenUpdated(): SagaIterator {
  const state: IAppState = yield select();

  if (!state.transientState.appIsInitialized) {
    yield take(LocalActions.APP_IS_INITIALIZED);
    yield take(LocalActions.APP_CONFIG_LOADED);
  }

  yield delay(0);
  yield put(
    new GlobalActions().requestModal(ModalType.RELOAD_NACH_BACKEND_ODER_APP_VERSIONS_CHANGE),
  );
  yield take(GlobalActions.CLOSE_MODAL);

  yield* saveResetAndReload();
}

function* saveResetAndReload(): SagaIterator {
  if (isStreckenApp(lastNavigatedAngebot.appId)) {
    const globalPut = GlobalPut.getInstance();
    yield call(
      globalPut.put.bind(globalPut),
      new GlobalActions().restoreStreckeSnapshot(
        lastNavigatedAngebot.appId,
        lastNavigatedAngebot.angebotsId,
      ),
    );

    yield call(
      globalPut.put.bind(globalPut),
      new GlobalActions().navigationRequested({ appId: App.SHOP_DASHBOARD }),
    );
    yield take(GlobalActions.NAVIGATION_COMPLETED);
  }

  yield put(new GlobalActions().speichernRequested());
  const saveStatusReceivedAction: GlobalAction<SpeichernStatus> = yield take(
    GlobalActions.SAVE_STATUS_RECEIVED,
  );
  yield call(reloadApp, saveStatusReceivedAction.payload.cryptId);
}

function* reloadApp(cryptId: string): SagaIterator {
  const href = yield call(buildAppUrlForReload, cryptId);
  setWindowLocation(href);
}

function* buildAppUrlForReload(cryptId: string): SagaIterator {
  const state: IAppState = yield select();

  const perid = state.transientState.datenhaltung.kdv.perId;
  const vorid = state.transientState.datenhaltung.kdv.vorId;

  const origin = window.location.origin;
  let href = origin + `?pid=${perid}&vorid=${vorid}&cryptid=${cryptId}`;
  const role =
    state.transientState.datenhaltung.sdw?.role !== null
      ? state.transientState.datenhaltung.sdw?.role
      : state.transientState.role.toLowerCase();

  if (state.transientState.role && state.transientState.isAnonToken) {
    href += '&role=' + role;
  }

  if (state.transientState.datenhaltung.sdw?.partyId !== null) {
    href += '&partyId=' + state.transientState.datenhaltung.sdw?.partyId;
  }

  return href;
}
